import type { UserRole } from '../utils/permissions'
import type { Project, ProjectMember } from './ProjectContext'

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function assertValidMemberEmail(email: string) {
  if (!EMAIL_PATTERN.test(email)) {
    throw new Error('유효하지 않은 이메일 주소입니다.')
  }
}

export function findProjectOrThrow(projects: Project[], projectId: string) {
  const project = projects.find((item) => item.id === projectId)
  if (!project) {
    throw new Error('프로젝트를 찾을 수 없습니다.')
  }
  return project
}

export function assertAuthenticatedProjectUser(
  currentUserEmail: string | null,
  message: string
): asserts currentUserEmail is string {
  if (!currentUserEmail) {
    throw new Error(message)
  }
}

export function assertProjectMemberAdmin(userRole: UserRole | null) {
  if (!userRole || !['owner', 'admin'].includes(userRole)) {
    throw new Error('멤버를 관리할 권한이 없습니다.')
  }
}

export function assertNewProjectMember(project: Project, email: string) {
  if (project.members.some((member) => member.email === email)) {
    throw new Error('이미 프로젝트 멤버입니다.')
  }
}

export function assertMutableProjectMember(project: Project, email: string) {
  if (email === project.owner) {
    throw new Error('프로젝트 소유자는 변경하거나 제거할 수 없습니다.')
  }
}

export function addMemberToProjectList(
  projects: Project[],
  projectId: string,
  newMember: ProjectMember
) {
  return projects.map((project) =>
    project.id === projectId
      ? { ...project, members: [...project.members, newMember] }
      : project
  )
}

export function updateMemberRoleInProjectList(
  projects: Project[],
  projectId: string,
  email: string,
  role: UserRole
) {
  return projects.map((project) =>
    project.id === projectId
      ? {
          ...project,
          members: project.members.map((member) =>
            member.email === email ? { ...member, role } : member
          ),
        }
      : project
  )
}

export function removeMemberFromProjectList(
  projects: Project[],
  projectId: string,
  email: string
) {
  return projects.map((project) =>
    project.id === projectId
      ? {
          ...project,
          members: project.members.filter((member) => member.email !== email),
        }
      : project
  )
}
